<template>
  <div class="page">
    <div class="goodscon">
      <div class="titlecon" v-if="detail">
        <div class="titleleft">
          <span>编号: {{ detail.no }}</span>

          <span v-if="detail.inOrderType&&detail.inOrderType.value == '0'">分拨人: {{ detail.inUser.title }}</span>
          <span>调拨来源: {{ detail.otherShopName }}</span>
          <span>调拨人: {{ detail.inUser.title }}</span>
          <span>调拨日期:
            {{ detail.inTime }}</span>
          <span>调拨数量: {{ orderSystemCount }}</span>
          <div>
            <span>调拨备注: {{ detail.remark }}</span>
          </div>
        </div>
        <div class="titleright">
          <el-button type="warning" @click="isBack()" size="small">返回</el-button>
        </div>
      </div>
      <div style="margin-top: 10px">
        <el-table default-expand-all row-class-name="row-expand-cove" show-summary :data="tableData"
          style="width: 100%">
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <span>{{ scope.row.productName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="规格">
            <template slot-scope="scope">
              <span>{{ scope.row.skuName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位">
            <template slot-scope="scope">
              <span>{{ scope.row.systemInspectiontUnit }}</span>
            </template>
          </el-table-column>

          <el-table-column label="接受数量">
            <template slot-scope="scope">

              <span v-if="scope.row.isAccept">{{ scope.row.shopInspectiontCount }}</span>
              <span v-if="scope.row.isAccept == false">
                <input class="el-input__inner" type="text" style="width: 100px" placeholder="接受数量"
                  v-model.lazy="scope.row.shopInspectiontCount" />
              </span>


            </template>
          </el-table-column>

          <el-table-column label="验收状态" width="180px">
            <template slot-scope="scope">
              <span v-if="scope.row.systemInspectiontCount <= scope.row.shopInspectiontCount">
                <span style="color: #13ce66">•</span>
                已验收 {{ scope.row.shopInspectiontCount }} / {{ scope.row.systemInspectiontCount }}
              </span>
              <span v-if="scope.row.systemInspectiontCount > scope.row.shopInspectiontCount &&
        scope.row.shopInspectiontCount != 0
        ">
                <span style="color: #e6a23c">•</span>
                部分验收 {{ scope.row.shopInspectiontCount }} / {{ scope.row.systemInspectiontCount }}
              </span>
              <span v-if="scope.row.shopInspectiontCount == 0">
                <span style="color: #e6a23c">•</span>
                未验收 {{ scope.row.shopInspectiontCount }} / {{ scope.row.systemInspectiontCount }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="footer" v-if="this.detail.status==1">
        <div></div>
        <div>
          <span style="margin-right: 10px">实收数量
            <strong style="color: #ff0000">{{ distributionTotalCount }}</strong>
          </span> 
          <el-button v-if="detail.orderAcceptStatus==0" class="desc" type="warning" @click="allReturn" >全部退回</el-button> 
          <el-button v-if="detail.orderAcceptStatus!=2"  class="desc"  type="primary" @click="shopnInspectiont">验货入库</el-button>
        </div>
      </div>
    </div>
  <!--全部退回的备注 -->
    <el-dialog title="提示" center :visible.sync="dialogCancelVisible" width="20%">
      <div style="margin: 15px 0px">退回备注</div>
      <el-input type="textarea" placeholder="请输入内容" v-model="cancelRemark">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCancelVisible = false">取消</el-button>
        <el-button type="warning" @click="sumbitCancelAll">确认退回</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
export default {
  data() {
    return {

      detail: {},
      tableData: [],
      orderId: "",
      orderSystemCount: 0,
      dialogCancelVisible:false,
      cancelRemark:"", 

    };
  },
  computed: {
    distributionTotalCount() {
      let _distributionTotalCount = 0;
      this.detail.orderItems.forEach((item) => {
        _distributionTotalCount += parseInt(item.shopInspectiontCount);
      });

      return _distributionTotalCount;
    },

  },
  created() {

    this.orderId = this.$route.query.id;
    this.getDetail();
  },

  methods: {

    getDetail() {
      let params = {
        inorderId: this.orderId,
      };
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_Url66 + "api/in/info", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.detail = res.data;
            this.tableData = this.detail.orderItems;
            this.detail.orderItems.forEach(e => {
              this.orderSystemCount += e.systemInspectiontCount;

            }); 
          }
        });
    },
    isBack() {
      this.$alert("你正在验货,返回数据将不会保存,确认返回", "确认返回", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.$router.push({
              path: "/rukuNew/rukuList",
              query: {
                tabs: 2,
              },
            });
          } else {
            this.$message({
              type: "info",
              message: "取消返回",
            });
          }
        },
      });
    },
 
 
    allReturn(){

      this.dialogCancelVisible=true
      
    },
    sumbitCancelAll(){
      if(this.cancelRemark.length<=0)
      {
        this.$message({
          type: "error",
          message: "退回原因不能为空",
        });
        return;
      }
      var self=this;
      let params = {
        orderId: this.orderId,
        remark:this.cancelRemark
      };
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_Url66 + "api/in/shop/cancel/inspection", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) { 
            
            this.$message({
              type: "success",
              message: "全部退回成功",
            }); 
            self.getDetail()
          }
          else{
            this.$message({
              type: "error",
              message: "全部退回失败:"+res.info,
            });
          }
        });
    },
    //门店验收
    shopnInspectiont() {
      var self=this;

      if(this.distributionTotalCount<=0)
      {
         
        this.$message({
          type: "error",
          message: "验收数量不能为空",
        });
        return;
      }
      let params = {
        inOrderNO: this.orderId,
        items:[]
      };
      this.detail.orderItems.forEach(item=>{
        params.items.push({
          productType:item.productType.value,
          productId:item.productId,
          skuId:item.skuId,
          unitId:item.systemInspectionUnitId,
          count:item.shopInspectiontCount
        });
      });
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_Url66 + "api/in/shop/inspection", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) { 
            
            this.$message({
              type: "success",
              message: "验货成功",
            }); 
            self.getDetail();
          }
          else{
            this.$message({
              type: "error",
              message: "验货失败:"+res.info,
            });
          }
        });

    }

  },
};
</script>

<style lang="scss">
.code_item {
  margin-right: 10px;
  color: #9d9d9d;
  border: 1px solid #9d9d9d;
  background: #f4f4f4;
  border-radius: 4px;
  border: 1px solid #9d9d9d;
  padding: 10px;
}

.code_item_active {
  padding: 10px;
  margin-right: 10px;
  background: #dbffe8;
  border-radius: 4px;
  color: #11b44b;
  border: 1px solid #11b44b;
}

.titlecon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  background-color: #fff;
  margin-bottom: 10px;
  padding: 10px 0px;

  .titleleft {
    span {
      margin: 5px 20px;
      display: inline-block;
    }
  }

  .titleright {
    margin-right: 20px;
    // margin-top: 20px;
  }
}

.comH2 {
  line-height: 64px;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.abnormalpopover {
  background-color: #000000;
  color: #fff;
}

.row-expand-cove .el-table__expand-icon {
  display: none;
}

.footer {
  background-color: #f5f5f5;
  position: fixed;
  bottom: 0;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  left: 220px;
  right: 0;
  padding-left: 20px;
  z-index: 200;

  .desc {
    margin-right: 20px;
  }
}
</style>
